module.exports = __webpack_public_path__ + "img/add-items.3b792e19.svg";